import { Data } from './data';

/** `changedBy` for changes no user made, e.g. a payment gateway notification. */
export const SYSTEM_ACTOR = 'system';

export interface AuditLogDto {
  id: string;
  entityId: string;
  entityType: string;
  fieldName: string | null;
  beforeValue: string | null;
  afterValue: string | null;
  changedAt: string;
  changedBy: string | null;
  reason: string | null;
  action?: string | null;
  scopeType?: string | null;
  scopeId?: string | null;
  data?: Data | null;
}

export interface Model {
  items: AuditLogDto[];
  meta: {
    currentPage: number;
    itemCount: number;
    itemsPerPage: number;
    totalItems: number;
    totalPages: number;
  };
}
